import { databaseFiltersName } from 'utils/consts'
import type { FiltersCollection } from '../filtersCollectionsRegistry'
import type { DatabaseFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import { pickEntries } from './entries'

type Role = string

export const getDatabaseExhibitionsFiltersCollection = (
  _role: Role
): FiltersCollection =>
  pickEntries([
    databaseFiltersName.dateStartFilter,
    databaseFiltersName.dateEndFilter,
    databaseFiltersName.countryFilter,
    databaseFiltersName.participantsFilter,
    databaseFiltersName.exhibitionTypeFilter,
  ])

export const databaseExhibitionsFiltersConfig: DatabaseFiltersConfig = {
  component: 'database',
  getFiltersCollection: getDatabaseExhibitionsFiltersCollection,
  showResultsTextKey: 'filters.button.apply',
}
